import { cn } from "@/lib/utils";

/** Composer autocomplete / slash-command popover shell. */
export const POPOVER_SURFACE_CLASSES =
  "absolute bottom-full left-0 z-50 mb-1 overflow-hidden rounded-lg border border-border bg-popover-opaque shadow-lg";

/** Row inside composer popovers (mentions, slash commands, emoji). */
export const POPOVER_ROW_BASE =
  "flex w-full min-w-0 items-center gap-2 px-3 py-2 text-left text-sm transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring";

export function popoverRowClasses(
  isSelected?: boolean,
  className?: string,
): string {
  return cn(
    POPOVER_ROW_BASE,
    "cursor-pointer",
    isSelected && "bg-muted",
    className,
  );
}

/** cmdk command palette shell — modal surface inside transparent DialogContent. */
export const COMMAND_PALETTE_SURFACE_CLASSES =
  "flex h-full w-full flex-col overflow-hidden rounded-lg border border-border bg-modal-opaque text-foreground shadow-lg";
